var map = {
	"./AmiPolymerDashboard.svg": 5651,
	"./Emailbox.svg": 5299,
	"./Messagebox.svg": 8101,
	"./Namebox.svg": 8090,
	"./Utegration.png": 6771,
	"./aboutmelogo.png": 8116,
	"./akshayAvatar.png": 690,
	"./akshayImage.png": 463,
	"./ami.jpg": 505,
	"./boe.png": 5546,
	"./cognizant.png": 9642,
	"./curriculum.png": 433,
	"./fortisalberta.png": 2656,
	"./gmail.svg": 5602,
	"./godrejDashboard.svg": 5538,
	"./graph-image.png": 9614,
	"./gyanholic.png": 8494,
	"./hotelManagementImage.svg": 5566,
	"./hrdashboard.svg": 3784,
	"./hrdashboard2.svg": 2638,
	"./i2econsulting.png": 282,
	"./internDashboard.svg": 1896,
	"./jobsupport.png": 247,
	"./kidsdashboard.svg": 5249,
	"./linkedin.png": 8518,
	"./linkedin.svg": 7657,
	"./logo.svg": 2835,
	"./logoFooter.svg": 7906,
	"./noise.png": 8976,
	"./powerBiTraining.png": 7940,
	"./practical.png": 8713,
	"./projectImage.png": 6370,
	"./salesdashboard.svg": 5488,
	"./telemedRxDashboard.svg": 1977,
	"./telemedrx.png": 9089,
	"./testimonialprofile.jpg": 337,
	"./traveldashboard.svg": 459,
	"./user.png": 4353,
	"./websiteIcon.svg": 9551,
	"./whatsapp.svg": 4511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;